module.exports = __webpack_public_path__ + "static/media/filexfer_128.d7f81eb9.ico";